import { Component, OnInit,Inject } from '@angular/core';
import {MdDialog, MdDialogRef, MD_DIALOG_DATA} from '@angular/material';
import {Device} from '../device';
import {ContactService} from '../contact.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { SidebarComponent } from '../sidebar/sidebar.component';
@Component({
  selector: 'app-show-caliberation',
  templateUrl: './show-caliberation.component.html',
  styleUrls: ['./show-caliberation.component.scss'],
  providers: [ContactService,SidebarComponent]
})
export class ShowCaliberationComponent implements OnInit {
  dname:any;
  constructor(public dialogRef: MdDialogRef<ShowCaliberationComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,private contactService: ContactService,private _flashMessagesService: FlashMessagesService,public sidebar :SidebarComponent){
   
   
      console.log(data);
    
     }
  

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/show-caliberation/show-caliberation.component.ts